export function arrayOrNull<T>(
  arr: Array<T | null> | null | undefined
): Array<T> | null {
  if (!Array.isArray(arr)) {
    return null;
  }
  const returnArr = arr.filter(Boolean) as Array<T>;
  return returnArr.length > 0 ? returnArr : null;
}
